import './modules/bling';
import newsrooms from './modules/newsrooms.json';

async function getData() {
  const r = await fetch(
    'https://media.mcclatchy.com/static/2020/covid-lp/data.json'
  );
  const json = await r.json();
  return json;
}

async function init() {
  const featured = $1('section.featured');
  const cards = $1('section.story-cards');
  const cardsFragment = new DocumentFragment();

  const data = await getData();

  for (const story of data.stories) {
    let card = document.createElement('article');
    card.className = 'card';

    let url = new URL(story.url);

    let domain = url.hostname.replace('www.', '');

    let newsroom = newsrooms[domain];

    card.innerHTML = `
      <figure>
      <a href="${story.url}">
      <img src="${story.img}" alt="Lead article image" />
      </a>
      </figure>
      <div class="package impact">
      <h6 class="kicker">${newsroom}</h6>
      <h3 class="${story.featured ? 'h1' : 'h3'}">
      <a href="${story.url}" style="--lc: #fff">${story.title}</a>
      </h3>
      <time>${story.date}</time>
      </div>
      `;

    if (story.featured) {
      card.classList.add('horizontal', 'in-depth');
      featured.appendChild(card);
    } else {
      cardsFragment.appendChild(card);
    }
  }
  cards.appendChild(cardsFragment);
}

init().catch(console.error);
